import React, { useRef,useState } from 'react';
import './index.less';
import { Link } from "react-router-dom";
import logo1 from '@/assets/bottom/address.png';

const  BottomPage =()=> {



    const NavClick = (path,event)=>{
      console.log(path)
      if(!path){
        event.preventDefault()
      }
    }

    return (  
      <div className='bottom_page'>
        <div className="middle">
          <div className="message">
                <div className="left_word">
                      <div className="cube">
                          <div className="bottom_bar">
                              <div className='line address'>
                                <div className="icon"><img src={logo1} alt="" /></div>
                                <p><span>公司地址:</span>广东省广州市黄埔区瑞吉二街45号804房</p>
                              </div>
                              <div className="tagline">
                                 专业的<span>智算产品</span>与解决方案<span>提供商</span>
                              </div>
                          </div>
                      </div>

                </div>
                <div className="right_line"></div>
          </div>
          <div className="jump">
             <div className="name">版权所有</div>
             <p className='call'>广州微分电子科技有限公司. All rights reserved.</p>
             <a rel="stylesheet" href="http://beian.miit.gov.cn/" target="_blank" className="cut">粤ICP备粤ICP备16103764号-1</a>  
             {/* <a rel="stylesheet" href="http://beian.miit.gov.cn/" target="_blank">粤公网安备44011202003163号</a>        */}
          </div>

        </div>

      </div>  
    );  
}
  
export default  BottomPage;